import { useEffect, useState } from 'react';
import api from '../api';
import { getCustomer, saveCustomer } from '../services/customerService';
import { useCart } from '../context/CartContext';
import { useFavorites } from '../context/FavoriteContext';
import { parseItems } from './useCustomerAction';
export default function useCustomerCollections() {
  const { dispatch: cart } = useCart(), { dispatch: favorites } = useFavorites();
  const [state, setState] = useState({ loading: true, verified: false, error: '' });
  const token = localStorage.getItem('customerAccessToken');
  const signedIn = Boolean(token && getCustomer()?.phone);
  useEffect(() => {
    let active = true;
    if (!signedIn) { setState({ loading: false, verified: false, error: '' }); return undefined; }
    setState({ loading: true, verified: false, error: '' });
    api.get('/api/auth/profile').then(({ data }) => {
      if (!active) return;
      saveCustomer({ phone: data.phone, name: data.name || '', savedPoints: data.savedPoints || [] });
      cart({ type: 'HYDRATE_CART', payload: parseItems(data.cart), ownerPhone: data.phone });
      favorites({ type: 'HYDRATE_FAVORITES', payload: parseItems(data.favorites), ownerPhone: data.phone });
      setState({ loading: false, verified: true, error: '' });
    }).catch(() => { if (active) setState({ loading: false, verified: false, error: 'Не удалось загрузить данные. Проверьте соединение или войдите снова.' }); });
    return () => { active = false; };
  }, [signedIn, token, cart, favorites]);
  return { ...state, signedIn };
}
